'use client'

import dynamic from 'next/dynamic'
import { useChatbotDialog } from '../hooks/useChatbotDialog'

const DynamicChatbotIndexedDbProvider = dynamic(() =>
	import('./ChatbotIndexedDbProvider').then(
		(mod) => mod.ChatbotIndexedDbProvider
	)
)

const DynamicChatbotMessagesProvider = dynamic(() =>
	import('./ChatbotMessagesProvider').then((mod) => mod.ChatbotMessagesProvider)
)

interface ChatbotProviderProps {
	readonly children: React.ReactNode
}

export function ChatbotProvider({ children }: ChatbotProviderProps) {
	const { isDialogOpen } = useChatbotDialog()

	return isDialogOpen ? (
		<DynamicChatbotIndexedDbProvider>
			<DynamicChatbotMessagesProvider>
				{children}
			</DynamicChatbotMessagesProvider>
		</DynamicChatbotIndexedDbProvider>
	) : null
}
